module.exports = __webpack_public_path__ + "static/media/sonder4.dec3fc31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/sonder4.jpg
// module id = 383
// module chunks = 0